module.exports = __webpack_public_path__ + "img/search-icon.0d309afe.svg";